import Link from "next/link";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";
import { getButtonVariantStylesAndSize, ButtonVariantTypes } from "components/ui/button";
import { AtomProps } from "../Atom/types";
import CarouselRows from "./CarouselRows";
type CarouselRow = Omit<AtomProps, "className">;

type CarouselProps = {
  className?: string;
  scrollByOneSlide?: boolean;
  rows?: CarouselRow[];
  title?: string;
  titleTag: React.ElementType;
  ctaText?: string;
  ctaUrl?: string;
  bgColor?: string;
};

const Carousel = ({
  title,
  ctaText,
  titleTag,
  bgColor,
  ctaUrl,
  scrollByOneSlide = false,
  rows = []
}: CarouselProps) => {
  const TitleTag = titleTag || "p";
  return (
    <section id="Carousel-70" style={{ backgroundColor: bgColor }}>
      <MaxWidthWrapper className="tile-container-y px-4 lg:px-12 xl:px-16 2xl:px-20">
        <div className="tile-title-container">
          <TitleTag className="tile-main-header pb-4 font-heading">{title}</TitleTag>

          {ctaText && ctaUrl && (
            <Link
              href={ctaUrl}
              className={getButtonVariantStylesAndSize({
                variant: ButtonVariantTypes.LINK,
                size: "defaultLink"
              })}
            >
              {ctaText}
            </Link>
          )}
        </div>
        <CarouselRows rows={rows} scrollByOneSlide={scrollByOneSlide} />
      </MaxWidthWrapper>
    </section>
  );
};

export default Carousel;
